import { z } from "zod";

export const projectTagItemSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export const projectTagsResponseSchema = z.object({
  results: z.array(projectTagItemSchema),
});

export type ProjectTagItem = z.infer<typeof projectTagItemSchema>;
export type ProjectTagsResponse = z.infer<typeof projectTagsResponseSchema>;
